<template>
  <div class='newplace'>
    <img src="/static/images/activty/howcoupon/howcoupon_01.jpg">
    <img src="/static/images/activty/howcoupon/howcoupon_02.jpg">
    <img src="/static/images/activty/howcoupon/howcoupon_03.jpg">
    <img src="/static/images/activty/howcoupon/howcoupon_04.jpg">
  </div>
</template>
<script>
export default {
  name: 'howcoupon',
  components: {},
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {},
  created() {
  },
  methods: {
    
  },
}

</script>
<style scoped>
.newplace{
  width: 100%;
}
.newplace img{
  width: 100%;
  display: block;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/howcoupon.vue